const UriLib = require('./src/UriLib');
const {
  KNOWN_TRACKER_QUERY_PARAMS,
  EXACT_TRACKER_QUERY_PARAMS,
  PREFIX_TRACKER_QUERY_PARAMS,
} = require('./src/constants');
const {
  matchesQueryParamEntry,
  normalizeUrlForWhitelist,
  isEmptyWhitelistAnomaly,
} = require('./src/QueryParamWhitelist');

module.exports = {
  UriLib,
  KNOWN_TRACKER_QUERY_PARAMS,
  EXACT_TRACKER_QUERY_PARAMS,
  PREFIX_TRACKER_QUERY_PARAMS,
  matchesQueryParamEntry,
  normalizeUrlForWhitelist,
  isEmptyWhitelistAnomaly,
};
